// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-chip--active[data-v-f7ddaeea] {\n  border: 2px solid var(--v-greenPrimary-base) !important;\n}\n.v-chip--active[data-v-f7ddaeea]::before {\n  background-color: white;\n}\n.theme--dark.v-tabs-items[data-v-f7ddaeea] {\n  background-color: transparent !important;\n}", ""]);
// Exports
module.exports = exports;
